var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BasicLayout',[_c('SportOrder',{staticClass:"section",attrs:{"id":_vm.id}}),_vm._v(" "),_c('SportLabels',{staticClass:"section",attrs:{"id":_vm.id}}),_vm._v(" "),_c('SportFederations',{staticClass:"section",attrs:{"id":_vm.id}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f6e6cb0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/sport/Sport.vue
// module id = null
// module chunks = 